import React, { Component } from "react";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../../component/autocomplete";
import axios from "axios";
import requester from "../../../lib/requester";

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      dataDetail: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: "",
      submittedDateTo: "",
      sAwbNo: "",
      error: [],
      success: "",
      header: [],
      lovStatus: [],
      lovReason: [],
      sAwbNumber: "",
      disabledAwbNumber: false,
      sAwbDate: "",
      disabledAwbDate: false,
      docStatus: "",
    };
  }

  componentDidMount = () => {
    this.handleSearch();
  };

  handleSearch = () => {
    let url = "/api/collect/v1/monitoring/get-detail-document";
    let { id } = this.props.match.params;
    let param = {
      doc_id: id,
    };
    this.setState({ loading: true });
    request.postCollect(url, param, {
      success: function (response) {
        let { header, detail } = response.data.data;

        let tanggal = "";

        tanggal = header.awb_date.length > 0 ? new Date(header.awb_date) : "";

        this.setState({
          header: header,
          loading: false,
          dataTable: detail,

          sAwbDate: tanggal,
          sAwbNumber: header.awb_no,
          docStatus: header.status,
        });

        let disAwbNumber = header.awb_no.length > 0 ? true : false;
        let disAwbDate = header.awb_date.length > 0 ? true : false;

        this.setState({disabledAwbNumber: disAwbNumber,disabledAwbDate : disAwbDate })


        // this.getProgramType();
        // this.getDocumentList();
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleSubmit = (e) => {
    if (this.validateSubmit()) {
      let { id } = this.props.match.params;
      let { user } = this.state;

      let param = {
        doc_id: id,
        org_id: user.org_id,
        rolename: user.role_name,
        username: user.username,
        org_name: user.org_name,
        awb_date: moment(this.state.sAwbDate).format("YYYY-MM-DD"),

        awb_no: this.state.sAwbNumber,
      };

      // console.log(param);

      this.setState({ loading: true });
      let url = "/api/collect/v1/monitoring/send-document";
      request.postCollect(url, param, {
        success: function (response) {
          let { message } = response.data;
          window.scrollTo(0, 0);
          this.setState({ loading: false, success: message, error: [] });
          window.setTimeout(() => {
            this.props.history.push("/admin/documentmonitor/summary");
            // window.location.reload();
          }, 2000);
        }.bind(this),
        error: function (e) {
          console.log(e);
        },
      });
    }
  };

  validateSubmit = () => {
    let error = [];

    if (this.state.sAwbNumber.length === 0) {
      error.push("Please input AWB Number");
    }
    if (this.state.sAwbDate.length === 0) {
      error.push("Please input AWB Date");
    }

    if (error.length > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      console.log(this.state.error);
      return false;
    } else {
      return true;
    }
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Invoice No",
          accessor: "trx_number",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 150,
        },
        {
          Header: "TTF No",
          accessor: "ttf_no",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 200,
        },
        {
          Header: "Customer Name",
          accessor: "cust_des_name",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 300,
        },
        {
          Header: "Status Received",
          accessor: "status",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 150,
        },
        {
          Header: "Reason Received",
          accessor: "reason",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 200,
        },
        {
          Header: "Notes Received",
          accessor: "notes",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 200,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        id="myTable"
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  handleChangeAwb = (e) => {
    this.state.sAwbNumber = e.target.value;
  };

  handleChangeAwbDate = (date) => {
    this.setState({ sAwbDate: date });
  };

  renderButton = () => {
    if (this.state.docStatus == "WAITING") {
      return (
        <div className="col-md-9">
          <div className="col-sm-8">
            <button
              type="button"
              className="btn btn-success"
              onClick={this.handleSubmit.bind(this)}
            >
              Send
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-danger"
              //   onClick={this.handleCancel.bind(this)}
              onClick={() => {
                this.props.history.push("/admin/documentmonitor/summary");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-md-9">
          <div className="col-sm-8">
            <button
              type="button"
              className="btn btn-secondary"
              // onClick={this.createPdf.bind(this)}
              onClick={() => {
                this.props.history.push("/admin/documentmonitor/summary");
              }}
            >
              back
            </button>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    {/* <form className="form-horizontal"> */}
                    <form className="form-horizontal">
                      {/* <h6>
                        Doc No: &nbsp; &nbsp; &nbsp; {this.state.header.doc_no}
                      </h6>
                      <h6>
                        Doc Date: &nbsp; &nbsp;{" "}
                        {this.state.header.doc_date !== null &&
                        this.state.header.doc_date !== "" &&
                        this.state.header.doc_date !== "null"
                          ? moment(new Date(this.state.header.doc_date)).format(
                              "DD-MMM-YYYY"
                            )
                          : ""}
                      </h6>
                      <h6>
                        Status : &nbsp; &nbsp; &nbsp; {this.state.header.status}{" "}
                      </h6> */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Doc No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                defaultValue={this.state.header.doc_no}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                defaultValue={this.state.header.status}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Doc Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={
                                  this.state.header.doc_date !== null &&
                                  this.state.header.doc_date !== "" &&
                                  this.state.header.doc_date !== "null"
                                    ? moment(
                                        new Date(this.state.header.doc_date)
                                      ).format("DD-MMM-YYYY")
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="clearfix">&nbsp;</div>
                      <div className="row">
                        <div className="col-lg-12">{this.renderTable()}</div>
                      </div>
                      &nbsp;
                      <hr />
                      <h4>Check AWB Number</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled={this.state.disabledAwbNumber}
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                onChange={this.handleChangeAwb.bind(this)}
                                defaultValue={this.state.sAwbNumber}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb Date
                            </label>
                            <div className="col-sm-8">
                              <DatePicker
                                disabled={this.state.disabledAwbDate}
                                selected={this.state.sAwbDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleChangeAwbDate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      &nbsp;
                      {/* <div className="row">
                        <div className="form-group row"> */}
                      {this.renderButton()}
                      {/* </div>
                      </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Detail;
